import React from 'react';

import type {
	ExtensionComponentProps,
	ExtensionManifest,
} from '@atlaskit/editor-common/extensions/extension-manifest';
import type { ExtensionParams } from '@atlaskit/editor-common/extensions/extension-handler';
import { getRedactionExtension } from '@atlassian/redaction-extension/main';

import { type RedactionExtensionParams } from '../redaction-constants.ts';

import { TourableRedactionExtensionLoader } from './TourableRedactionExtensionLoader.tsx';

// Confluence consumes the shared platform redaction extension so it inherits the
// platform node contract (extension type, delete-only toolbar via
// `hideCopyButton`, and any future platform hardening) rather than maintaining a
// forked manifest. Only the marker render is overridden, to host Confluence's
// onboarding tour; everything else comes from the platform node.
export const createTourableRedactionExtension = ({
	contentId,
	isCommentContext = false,
}: {
	contentId?: string | null;
	isCommentContext?: boolean;
}): ExtensionManifest => {
	const baseExtension = getRedactionExtension();
	const baseNodes = baseExtension.modules.nodes ?? {};

	return {
		...baseExtension,
		modules: {
			...baseExtension.modules,
			nodes: {
				...baseNodes,
				default: {
					...baseNodes.default,
					render: async () => (args: ExtensionComponentProps) => {
						const node = args.node as ExtensionParams<RedactionExtensionParams>;
						return (
							<TourableRedactionExtensionLoader
								contentId={contentId}
								extensionNode={node}
								isCommentContext={isCommentContext}
							/>
						);
					},
				},
			},
		},
	} as ExtensionManifest;
};
